import { render, staticRenderFns } from "./ot-table-wrapper.vue?vue&type=template&id=2863cc70&scoped=true&"
import script from "./ot-table-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-table-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-table-wrapper.vue?vue&type=style&index=0&id=2863cc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2863cc70",
  null
  
)

export default component.exports